var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-title-bar-scroll-page',{ref:"container",attrs:{"title":"拼团"}},[_c('my-img',{staticStyle:{"width":"100vw"},attrs:{"url":"https://cdn.keihong.tech/img/202501101805014.png"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }